import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import drawerSetting from './drawer/approval-drawer';
import ccDrawer from './drawer/cc';
import branchSetting from './drawer/branch-drawer';
import FlowNodeEnd from './node/flow-node-end';
import FlowNode from './node/flow-node';
import { approvalForm, warning, branchFormItem } from './examples';
import { v4 as uuidv4 } from 'uuid';
export default {
  name: 'Flow',
  components: {
    FlowNode: FlowNode,
    drawerSetting: drawerSetting,
    branchSetting: branchSetting,
    FlowNodeEnd: FlowNodeEnd,
    ccDrawer: ccDrawer
  },
  props: {
    // 数据源
    source: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    baseInfo: {
      type: Object,
      default: function _default() {}
    },
    directorLevel: {
      type: Number
    },
    selectData: {
      type: Object,
      default: function _default() {}
    }
  },
  provide: function provide() {
    return {
      updateFlow: this.updateFlow,
      // 更新视图
      handlerSelected: this.selectdData,
      // 选中节点的方法
      selectedId: this.selectedId,
      // 当前选中节点
      handlerAddNode: this.handlerAddNode,
      // 添加节点
      handerSetting: this.handerSetting // 节点配置
    };
  },
  data: function data() {
    return {
      currentNode: {},
      // 当前选中节点
      drawer: false,
      // 审批人组件展示
      ccDrawer: false,
      // 抄送人Drawer展示
      branchDrawer: false,
      // 条件分支组件展示
      sponsorDrawer: false,
      // 发起人展示
      selectedId: '',
      // 选中节点ID
      sourceData: this.source.nodeConfig
    };
  },
  computed: {
    type: function type() {
      var _this = this;
      var audit = this.selectData.audit || [];
      var item = audit.filter(function (item) {
        return item.audit_type === _this.baseInfo.audit_type;
      });
      return item[0] || {};
    }
  },
  watch: {
    source: {
      handler: function handler(v) {
        this.sourceData = JSON.parse(JSON.stringify(v.nodeConfig));
      },
      deep: true
    }
  },
  methods: {
    /**
     *  @description 添加节点
     *  @param { Object | Array } item 当前节点或当前条件分支集合
     *  @param { Number } type 节点类型  1 发起人  3 条件分支 2 审批人 7添加多个条件
     */
    handlerAddNode: function handlerAddNode(item, type, branch) {
      if (type === 1 || type === 2) this.handlerApporvalAdd(item, branch, type);
      if (type === 3) this.handlerAddConditional(item, branch);
      // 添加更多条件
      if (type === 7) {
        // if (item.length === 10) return this.$message.warning(this.$t('work_rule_60')) // 添加条件不得超过十条
        item.splice(-1, 0, {
          type: 3,
          nodeName: this.$t('work_rule_49', {
            x: item.length
          }),
          nodeCode: uuidv4(),
          form: [[branchFormItem()]],
          isDefault: false,
          warning: warning(3),
          childNode: {
            nodeName: this.$t('work_rule_48'),
            nodeCode: uuidv4(),
            form: approvalForm(),
            warning: warning(1),
            type: 1
          }
        });
      }
      // 更新视图
      this.updateSource();
    },
    /**
     *  @description 审批人添加
     *  @param { Object } data 目标对象
     */
    handlerApporvalAdd: function handlerApporvalAdd(data, branch, type) {
      var childNode = data.childNode,
        conditionList = data.conditionList;
      // 审批人或抄送人
      var msg = {
        nodeName: this.$t(type === 1 ? 'work_rule_48' : '734'),
        nodeCode: uuidv4(),
        form: approvalForm(type === 2),
        warning: warning(1),
        type: type,
        childNode: childNode
      };
      if (branch) {
        this.$set(data, 'childNode', msg);
        return false;
      }
      if (conditionList) {
        delete data.conditionList;
        msg.conditionList = conditionList;
      }
      this.$set(data, 'childNode', msg);
    },
    /**
     *  @description 添加条件
     *  @param { Object } data 目标对象
     */
    handlerAddConditional: function handlerAddConditional(data, branch) {
      var _this2 = this;
      var childNode = data.childNode;
      var msg = Array.from({
        length: 2
      }).map(function (item, index) {
        return {
          nodeName: index === 1 ? _this2.$t('work_rule_50') : _this2.$t('work_rule_49', {
            x: index + 1
          }),
          type: 3,
          nodeCode: uuidv4(),
          isDefault: index === 1,
          form: [[branchFormItem()]],
          warning: warning(3),
          childNode: index === 1 ? null : {
            nodeName: _this2.$t('work_rule_48'),
            nodeCode: uuidv4(),
            form: approvalForm(),
            warning: warning(1),
            type: 1
          }
        };
      });
      if (branch) {
        data.childNode = {
          nodeType: 2,
          id: uuidv4(),
          conditionList: msg,
          form: {}
        };
        if (childNode) data.childNode.childNode = childNode;
        return false;
      }
      data.conditionList = msg;
    },
    // 删除节点
    // @parma { obj } 要删除的节点
    handlerDel: function handlerDel(obj) {
      var _this3 = this;
      var deepDel = function deepDel(data) {
        var childNode = data.childNode,
          conditionList = data.conditionList;
        if (obj.nodeCode === data.nodeCode) return _this3.handlerDel(data);
        if (conditionList) {
          conditionList.forEach(function (element, index) {
            if (element.nodeCode !== obj.nodeCode) return deepDel(element);
            if (conditionList.length <= 2) {
              delete data.conditionList;
              if (data.type === 2) _this3.handlerDel(data);
              return false;
            }
            conditionList.splice(index, 1);
          });
        }
        if (!childNode) return false;
        // 子节点的childnode 和 conditionList绑定到当前节点上
        if (obj.nodeCode === childNode.nodeCode) {
          delete data.childNode;
          if (childNode.childNode) data.childNode = childNode.childNode;
          return false;
        }
        // 如果子节点还有子节点 把子节点传入
        if (childNode.childNode || childNode.conditionList) deepDel(childNode);
      };
      deepDel(this.sourceData);
      this.updateSource();
    },
    // 视图更新
    updateSource: function updateSource() {
      var source = JSON.parse(JSON.stringify(this.sourceData)); // this.sourceData
      this.sourceData = source;
    },
    /**
     *  @param { Object } data 当前选中节点
     *  @description data.type 节点类型 不同节点展示相应组件
     */
    selectdData: function selectdData(data) {
      // 1 发起人 3 条件分支 4 审批人
      switch (data.type) {
        case 0:
          this.sponsorDrawer = true;
          break;
        case 1:
          this.drawer = true;
          break;
        case 2:
          this.ccDrawer = true;
          break;
        case 3:
          this.branchDrawer = !data.isDefault;
          break;
      }
      // 选中节点
      this.currentNode = data;
      // 选中节点ID
      this.selectedId = data.nodeCode;
    },
    // 数据存储
    handlerChange: function handlerChange(obj) {
      var _this4 = this;
      Object.keys(obj).map(function (item) {
        return _this4.currentNode[item] = obj[item];
      });
      this.updateSource();
    },
    save: function save() {
      this.source.nodeConfig = this.sourceData;
    }
  }
};